import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || '/api';

export const api = axios.create({
  baseURL: API_BASE,
});

const authHeaders = () => {
  const token = localStorage.getItem('discord_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const streamsApi = {
  getLive: () => api.get('/streams/live').then((r) => r.data),
  getTop: (limit = 20) => api.get(`/streams/top?limit=${limit}`).then((r) => r.data),
  getAll: () => api.get('/streams').then((r) => r.data),
  search: (query) => api.get(`/streams/search?q=${encodeURIComponent(query)}`).then((r) => r.data),
  vote: (id) => api.post(`/streams/${id}/vote`, {}, { headers: authHeaders() }).then((r) => r.data),
  unvote: (id) => api.delete(`/streams/${id}/vote`, { headers: authHeaders() }).then((r) => r.data),
  getMyVote: (id) => api.get(`/streams/${id}/vote`, { headers: authHeaders() }).then((r) => r.data),
};

export const communityApi = {
  getRecent: (limit = 10) => api.get(`/community/recent?limit=${limit}`).then((r) => r.data),
  list: ({ limit = 50, offset = 0, q = '', sort = 'newest' } = {}) => {
    const params = new URLSearchParams({ limit, offset, sort });
    if (q) params.set('q', q);
    return api.get(`/community?${params.toString()}`).then((r) => r.data);
  },
};

export const chatApi = {
  fetch: (since = 0, limit = 50) => api.get(`/chat?since=${since}&limit=${limit}`).then((r) => r.data),
  send: (content) => api.post('/chat', { content }, { headers: authHeaders() }).then((r) => r.data),
};

export const discordApi = {
  widget: () => api.get('/discord/widget').then((r) => r.data),
};

export const clipsApi = {
  getTop: (limit = 24) => api.get(`/clips?limit=${limit}`).then((r) => r.data),
};

export const twitchApi = {
  say: (channel, message) => api.post('/twitch/say', { channel, message }, { headers: authHeaders() }).then((r) => r.data),
};

export const giveawayApi = {
  create: (data) => api.post('/giveaways', data, { headers: authHeaders() }).then((r) => r.data),
  list: () => api.get('/giveaways', { headers: authHeaders() }).then((r) => r.data),
  getById: (id) => api.get(`/giveaways/${id}`, { headers: authHeaders() }).then((r) => r.data),
  end: (id) => api.post(`/giveaways/${id}/end`, {}, { headers: authHeaders() }).then((r) => r.data),
  drawWinner: (id) => api.post(`/giveaways/${id}/draw-winner`, {}, { headers: authHeaders() }).then((r) => r.data),
};

export const streamerAccountApi = {
  getAccount: () => api.get('/streamer/account', { headers: authHeaders() }).then((r) => r.data),
  setLive: (live) => api.post('/streamer/account/live', { live }, { headers: authHeaders() }).then((r) => r.data),
  redeemCoins: (coins) => api.post('/streamer/account/redeem', { coins }, { headers: authHeaders() }).then((r) => r.data),
  getRedeemHistory: () => api.get('/streamer/account/redeem-history', { headers: authHeaders() }).then((r) => r.data),
  confirmPayout: (redemptionId, note) => api.post(`/streamer/account/redeem/${redemptionId}/confirm`, { note }, { headers: authHeaders() }).then((r) => r.data),
  getPayouts: () => api.get('/streamer/account/payouts', { headers: authHeaders() }).then((r) => r.data),
  getPayoutsForStreamer: (streamerId) => api.get(`/streamer/account/payouts/${streamerId}`, { headers: authHeaders() }).then((r) => r.data),
  getPendingPayoutCount: () => api.get('/streamer/account/pending-count', { headers: authHeaders() }).then((r) => r.data),
  getWallets: () => api.get('/streamer/account/wallets', { headers: authHeaders() }).then((r) => r.data),
};
